import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MapMarker} from '../../google-map/MapMarker';

@Component({
  selector: 'digires-location-picker-map',
  templateUrl: './location-picker-map.component.html',
  styleUrls: ['./location-picker-map.component.scss']
})
export class LocationPickerMapComponent implements OnInit {

  @Input() position: {latitude: number, longitude: number};
  @Output() mapClicked = new EventEmitter<{latitude: number, longitude: number}>();

  public markers: MapMarker[] = [];
  public zoom = 8;
  public center: google.maps.LatLng;

  ngOnInit(): void {
    this.updateMarker(new google.maps.LatLng(this.position.latitude, this.position.longitude));
  }

  public onMapClicked(event: google.maps.LatLng): void {
    this.updateMarker(event);
    this.mapClicked.emit({latitude: event.lat(), longitude: event.lng()});
  }

  private updateMarker(location: google.maps.LatLng) {
    this.center = location;
    this.markers = [];
    const marker: MapMarker = {
      visible: true,
      position: this.center
    };
    this.markers.push(marker);
  }

}
